import {
  Link,
  useLoaderData,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import "./styles.css";
import GenericErrorDisplay from "../generic-error";
import ResourceDisplay from "../../components/resource-display";
import useScrollPosition from "../../hooks/useScrollPosition";
import ButtonPrimarySide from "../../components/button-primary-side/index";

import { path as aboutPath } from "../pages-despre-noi/index.jsx";
import { path as comitetePath } from "../pages-despre-noi/pages-comitete/index.jsx";
import { path as scomePath } from "../pages-despre-noi/pages-comitete/page-scome/index.jsx";
import { path as exchangesPath } from "../pages-despre-noi/pages-comitete/page-exchanges/index.jsx";
import { path as scorpPath } from "../pages-despre-noi/pages-comitete/page-scorp/index.jsx";
import { path as scophPath } from "../pages-despre-noi/pages-comitete/page-scoph/index.jsx";
import { path as scoraPath } from "../pages-despre-noi/pages-comitete/page-scora/index.jsx";
import { OutputStructureGroup } from "../../dtos/structure";
import CardStructure from "../../components/card-structure/index";
import paperCutImage from "../../images/white-paper-cut.svg";
import NewsSummaryCard from "../../components/news-summary-card/index";
import { IMAGE_HOST } from "../../api/config";
import { path as newsPath } from "../pages-noutati/index.jsx";
import { path as supportPath } from "../page-sustine/index.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingHeart } from "@fortawesome/free-solid-svg-icons";
import { path as projectsPath } from "../pages-despre-noi/pages-proiecte/index.jsx";
import { path as inConstructionPath } from "../page-in-constructie/index.jsx";
import ResourceService from "../../service/resource";
import NewsService from "../../service/news";
import StructureService from "../../service/structure";

const resourceKeys = {
  logoRight: "logo-fasmr-text-right-white",
  aboutCover: "index-about-cover",
  aboutTitle: "index-about-title",
  aboutText: "index-about-text",
  fieldsTitle: "index-fields-title",

  scomeTitle: "index-fields-scome-title",
  scomeText: "index-fields-scome-text",
  scopeTitle: "index-fields-scope-title",
  scopeText: "index-fields-scope-text",
  scoreTitle: "index-fields-score-title",
  scoreText: "index-fields-score-text",
  scorpTitle: "index-fields-scorp-title",
  scorpText: "index-fields-scorp-text",
  scophTitle: "index-fields-scoph-title",
  scophText: "index-fields-scoph-text",
  scoraTitle: "index-fields-scora-title",
  scoraText: "index-fields-scora-text",

  projectsTitle: "index-projects-title",
  projectsText: "index-projects-text",

  joinTitle: "index-join-title",
  joinText: "index-join-text",
  joinImage: "index-join-image",

  newsTitle: "news-list-title",
  newsCover: "image-paper-white",

  supportTitle: "support-index-title",
};

const NEWS_ON_INDEX_COUNT = 4;

export async function loader() {
  const resources = new ResourceService().read.byIds(
    Object.values(resourceKeys)
  );
  const projects = new StructureService().read.byGroup(
    OutputStructureGroup.project
  );
  const news = new NewsService().read.list(1, NEWS_ON_INDEX_COUNT);

  return [await resources, await projects, await news];
}

export function Component() {
  const [resources, projects, news] = useLoaderData();

  const scrollPosition = useScrollPosition();

  const navigate = useNavigate();

  return (
    <div id="page-index">
      <header
        className="intro"
        style={{ height: scrollPosition === 0 && "100dvh" }}
      >
        <div style={{ height: "var(--gap-big)" }} />
        <div className="stretcher" />
        <ResourceDisplay
          resource={resources[resourceKeys.logoRight]}
          className="cover-logo"
        />
        <div className="stretcher" />
        <h4>
          Împreună facem în continuare <b>diferența!</b>
        </h4>
        <div style={{ height: "var(--gap-big)" }} />
      </header>
      <section className="about">
        <div className="content-container container">
          <ResourceDisplay
            resource={resources[resourceKeys.aboutTitle]}
            wrapper="h2"
          />
          <ResourceDisplay
            resource={resources[resourceKeys.aboutText]}
            className="text-container"
          />
          <ButtonPrimarySide
            title="Află mai multe"
            style={{ alignSelf: "flex-start" }}
            onClick={() => navigate(aboutPath)}
          />
          <ResourceDisplay
            resource={resources[resourceKeys.aboutCover]}
            className="cover"
          />
        </div>
      </section>
      <section className="fields">
        <div className="content-container container">
          <ResourceDisplay
            resource={resources[resourceKeys.fieldsTitle]}
            wrapper="h2"
          />
          <div className="content">
            <>
              {/* SCOME */}
              <ResourceDisplay
                resource={resources[resourceKeys.scomeTitle]}
                className="card scome"
                wrapper="h3"
              />
              <div className="description">
                <ResourceDisplay resource={resources[resourceKeys.scomeText]} />
                <Link
                  to={aboutPath + comitetePath + scomePath}
                  className="fill-secondary-button"
                >
                  Află mai multe
                </Link>
              </div>
            </>
            <>
              {/* SCOPE */}
              <ResourceDisplay
                resource={resources[resourceKeys.scopeTitle]}
                className="card scope"
                wrapper="h3"
              />
              <div className="description">
                <ResourceDisplay resource={resources[resourceKeys.scopeText]} />
                <Link
                  to={aboutPath + comitetePath + exchangesPath}
                  className="fill-secondary-button"
                >
                  Află mai multe
                </Link>
              </div>
            </>
            <>
              {/* SCORE */}
              <ResourceDisplay
                resource={resources[resourceKeys.scoreTitle]}
                className="card score"
                wrapper="h3"
              />
              <div className="description">
                <ResourceDisplay resource={resources[resourceKeys.scoreText]} />
                <Link
                  to={aboutPath + comitetePath + exchangesPath}
                  className="fill-secondary-button"
                >
                  Află mai multe
                </Link>
              </div>
            </>
            <>
              {/* SCOME */}
              <ResourceDisplay
                resource={resources[resourceKeys.scorpTitle]}
                className="card scorp"
                wrapper="h3"
              />
              <div className="description">
                <ResourceDisplay resource={resources[resourceKeys.scorpText]} />
                <Link
                  to={aboutPath + comitetePath + scorpPath}
                  className="fill-secondary-button"
                >
                  Află mai multe
                </Link>
              </div>
            </>
            <>
              {/* SCOPH */}
              <ResourceDisplay
                resource={resources[resourceKeys.scophTitle]}
                className="card scoph"
                wrapper="h3"
              />
              <div className="description">
                <ResourceDisplay resource={resources[resourceKeys.scophText]} />
                <Link
                  to={aboutPath + comitetePath + scophPath}
                  className="fill-secondary-button"
                >
                  Află mai multe
                </Link>
              </div>
            </>
            <>
              {/* SCORA */}
              <ResourceDisplay
                resource={resources[resourceKeys.scoraTitle]}
                className="card scora"
                wrapper="h3"
              />
              <div className="description">
                <ResourceDisplay resource={resources[resourceKeys.scoraText]} />
                <Link
                  to={aboutPath + comitetePath + scoraPath}
                  className="fill-secondary-button"
                >
                  Află mai multe
                </Link>
              </div>
            </>
          </div>
        </div>
      </section>
      <section className="projects">
        <div className="content-container container">
          <ResourceDisplay
            resource={resources[resourceKeys.projectsTitle]}
            wrapper="h2"
          />
          <ResourceDisplay
            resource={resources[resourceKeys.projectsText]}
            className="text-container"
          />
          <div className="cards-grid">
            {projects?.map((project, index) => (
              <CardStructure
                key={index}
                treeRoot={aboutPath + projectsPath}
                structure={project}
                inverse
              />
            ))}
          </div>
        </div>
      </section>
      <section className="join">
        <div className="paper-cut">
          <img src={paperCutImage} alt="" />
        </div>
        <div className="content">
          <div className="text">
            <ResourceDisplay
              resource={resources[resourceKeys.joinTitle]}
              wrapper="h2"
            />
            <ResourceDisplay resource={resources[resourceKeys.joinText]} />
            <Link to={inConstructionPath} className="fill-button">
              Află mai multe
            </Link>
          </div>
          <ResourceDisplay
            resource={resources[resourceKeys.joinImage]}
            className="image"
          />
        </div>
      </section>
      <section
        className="news"
        style={
          resources[resourceKeys.newsCover] && {
            "--background-image-url":
              "url(" +
              IMAGE_HOST +
              resources[resourceKeys.newsCover].value +
              ")",
          }
        }
      >
        <ResourceDisplay
          resource={resources[resourceKeys.newsTitle]}
          wrapper="h2"
        />
        <Link to={newsPath} className="fill-button">
          Vezi toate noutățile
        </Link>
        <div className="content-container container">
          {news.map((newsSummary, index) => (
            <NewsSummaryCard newsSummary={newsSummary} key={newsSummary.id} />
          ))}
        </div>
        <Link to={newsPath} className="fill-secondary-button">
          Vezi toate noutățile
        </Link>
      </section>
      <section className="support">
        <Link to={supportPath} className="fill-secondary-button">
          Află mai multe
        </Link>
        <div className="text">
          <FontAwesomeIcon icon={faHandHoldingHeart} />
          <ResourceDisplay
            resource={resources[resourceKeys.supportTitle]}
            wrapper="h2"
          />
        </div>
      </section>
    </div>
  );
}
Component.displayName = "page-index";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-index-error";
